var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.8 35.05Q14 33 17.175 31.975 20.35 30.95 24 30.95q3.65 0 6.825 1.025Q34 33 37.3 35.05q2.15-2.8 3-5.45.85-2.65.85-5.6 0-7.3-4.925-12.225T24 6.85q-7.3 0-12.225 4.925T6.85 24q0 2.95.875 5.6.875 2.65 3.075 5.45zM24 26.1q-3.15 0-5.3-2.15t-2.15-5.3q0-3.15 2.15-5.3T24 11.2q3.15 0 5.3 2.15t2.15 5.3q0 3.15-2.15 5.3T24 26.1zm-.05 18.7q-4.25 0-8.05-1.65-3.8-1.65-6.625-4.5t-4.45-6.625Q3.2 28.25 3.2 23.95q0-4.25 1.65-8.025 1.65-3.775 4.5-6.6Q12.2 6.5 15.975 4.85 19.75 3.2 24.05 3.2q4.25 0 8.025 1.65 3.775 1.65 6.6 4.475 2.825 2.825 4.475 6.6Q44.8 19.7 44.8 24q0 4.25-1.65 8.025-1.65 3.775-4.475 6.625-2.825 2.85-6.6 4.5Q28.3 44.8 23.95 44.8z"
  })));
}

export default SvgPerson;